



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { LOCALES, getLocaleOption, setLocale } from '../i18n';

@Component({})
export default class LanguageSwitcher extends Vue {
  @Prop({ default: false }) inline: boolean;

  get locales() {
    return LOCALES;
  }

  get activeLocale() {
    return getLocaleOption(this.$i18n.locale);
  }

  change(code: string) {
    setLocale(code);
  }
}
